

import Benefits from "./components/Benefits";

import Hero from "./components/Hero";
import Footer from "./components/Footer";
import Navbar from "./components/NavBar";
const MebLanding = () => {
  return (
 <>
 <Navbar></Navbar>
 <Hero></Hero>
 <Benefits></Benefits>
  
  
  <Footer></Footer>

</>
  );
};

export default MebLanding;
